// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DataSourceTreeContainer.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

/**
 * DataSourceTree component
 */

import React, { Component, PropTypes } from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import EventsUtils from 'EventUtils';
import DataTreeLazyLoading from '../DataSourceTree/Izenda.DataSourceTreeLazyLoading';
import { SIMPLE, BUNDLE } from 'logic/data/Izenda.ReportDesignerConstants';
import SearchTextBox from 'share/components/controls/Izenda.SearchTextBox';
import Input from 'share/components/controls/Izenda.Input';
import { isNil } from 'lodash/fp';
@connect()
class DataSourceTreeContainer extends Component {
  static propTypes = {
    store: PropTypes.object.isRequired
  };

  componentDidMount() {
    const { loader, store } = this.props;
    loader.startLoading();

    return store
      .startLoadingRelationship()
      .then(store.loadInitial.bind(store))
      .then(store.endLoadingRelationship.bind(store))
      .finally(loader.endLoading.bind(loader));
  }

  onDistinctChange = (e: Event) => {
    const { store } = this.props;
    store.reportStore.model.markDirty();
    store.model.changeDistinct(e.target.checked);
  };

  onChangeSearchText = (e: Event) => {
    const { store } = this.props;
    const searchKey = e.target.value;
    store.dataTree.filterText = searchKey;
    store.lazyLoadingQuerySource(null, true, searchKey);
  };

  renderControls = () => {
    const {
      localization,
      store: { model, dataTree }
    } = this.props;
    const showAllowNull = dataTree.showAllowNull && model.reportMode === SIMPLE;

    return (
      <div className="header-panel">
        <div className="izenda-MiddlePanel-checkbox">
          <div className="overflow-text">
            <Input type="checkbox" checked={model.distinct} onChange={this.onDistinctChange} />
            <span className="u_marginLeftInnerSpace">{localization.getText('REPORTDESIGNER_LABEL_DISTINCT')}</span>
          </div>
        </div>

        {showAllowNull && (
          <div className="izenda-MiddlePanel-checkbox">
            <div className="overflow-text" title={BUNDLE.MESSAGE.ALLOW_NULL_TOOLTIP}>
              <Input
                type="checkbox"
                onChange={EventsUtils.notifyChange(model.changeAllowNull.bind(model), EventsUtils.CHECKBOX)}
              />
              <span className="u_marginLeftInnerSpace">{localization.getText('REPORTDESIGNER_LABEL_ALLOW_NULLS')}</span>
            </div>
          </div>
        )}
      </div>
    );
  };

  render() {
    const {
      store,
      store: {
        dataTree,
        model: { reportMode }
      }
    } = this.props;

    return (
      <section className="u_fullHeight u-posRelative u-bgWhite">
        <div className="izenda-MiddlePanel-search">
          {this.renderControls()}
          <div className="search-box">
            <SearchTextBox value={dataTree.filterText} onChange={this.onChangeSearchText} />
          </div>
          <hr />
        </div>
        {!isNil(reportMode) && <DataTreeLazyLoading className="izenda-MiddlePanel-content" store={store} />}
      </section>
    );
  }
}

export default DataSourceTreeContainer;



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/DataSource/Izenda.DataSourceTreeContainer.js